import createReactComponent from '../createReactComponent';
export default createReactComponent('brand-kbin', 'IconBrandKbin', [
  ['g', { key: 'svg-0', strokeWidth: '1.838' }],
]);
